import chroma from 'chroma-js';
import parse from 'parse-css-color';
import defaultTheme from '@amzn/stencil-react-theme-default';
import { LABEL_ERROR_COLOR, LABEL_WARNING_COLOR } from "./";
import { getValueOrNull } from "./utils";

var parseCssColorToChromaColor = function parseCssColorToChromaColor(colorString) {
  var rgbHex = parse(colorString);
  var color;

  switch (rgbHex.type) {
    case 'hsl':
      color = chroma(rgbHex.values[0], rgbHex.values[1] / 100, rgbHex.values[2] / 100, rgbHex.type);
      break;

    case 'rgb':
      color = chroma(rgbHex.values[0], rgbHex.values[1], rgbHex.values[2], rgbHex.type);
      break;

    default:
      throw Error("Could not parse color ".concat(colorString));
  }

  return color;
};

export var opacify = function opacify(cssColor, amount) {
  try {
    return parseCssColorToChromaColor(cssColor).alpha(amount).css();
  } catch (error) {
    return '#000000';
  }
};
export var darken = function darken(cssColor, amount) {
  var value = 1 - (amount < 0 ? 0 : amount > 1 ? 1 : amount);

  var darkenRgbChannel = function darkenRgbChannel(currentValue) {
    return currentValue * value;
  };

  try {
    var inputColor = parseCssColorToChromaColor(cssColor);
    return inputColor.set('rgb.r', darkenRgbChannel(inputColor.get('rgb.r'))).set('rgb.g', darkenRgbChannel(inputColor.get('rgb.g'))).set('rgb.b', darkenRgbChannel(inputColor.get('rgb.b'))).hex();
  } catch (_unused) {
    return '#000000';
  }
};
export var lighten = function lighten(cssColor, amount) {
  var value = amount < 0 ? 0 : amount > 1 ? 1 : amount;

  var lightenRgbChannel = function lightenRgbChannel(currentValue) {
    return currentValue + (255 - currentValue) * value;
  };

  try {
    var inputColor = parseCssColorToChromaColor(cssColor);
    return inputColor.set('rgb.r', lightenRgbChannel(inputColor.get('rgb.r'))).set('rgb.g', lightenRgbChannel(inputColor.get('rgb.g'))).set('rgb.b', lightenRgbChannel(inputColor.get('rgb.b'))).hex();
  } catch (_unused2) {
    return '#000000';
  }
};
export var getDarkerColorFromThemeColors = function getDarkerColorFromThemeColors(themeColors, color) {
  var colorGrades = color.match(/\d+/);
  var defaultValue = getValueOrNull(themeColors, color);

  if (!colorGrades) {
    return defaultValue;
  }

  var colorGrade = parseInt(colorGrades[0]);
  var colorBase = color.replace("".concat(colorGrade), '');
  var minorColorGrade = "".concat(colorGrade + 5);
  var minorHoverColor = getValueOrNull(themeColors, "".concat(colorBase).concat(minorColorGrade.length === 1 ? "0".concat(minorColorGrade) : minorColorGrade));
  return minorHoverColor || getValueOrNull(themeColors, "".concat(colorBase).concat(colorGrade + 10)) || defaultValue;
};
export var getErrorColorOverride = function getErrorColorOverride(error, warning) {
  if (error) {
    return LABEL_ERROR_COLOR;
  }

  if (warning) {
    return LABEL_WARNING_COLOR;
  }

  return undefined;
};
export var getHexColorFromTheme = function getHexColorFromTheme(color) {
  return defaultTheme.color[color];
};
export var getRgbColorFromTheme = function getRgbColorFromTheme(color) {
  var hexColor = defaultTheme.color[color]; // Chroma returns the color in the format "rgb(X,X,X)", in CSS it's rendered
  // as "rgb(X, X, X)" (note the spaces)

  return chroma(hexColor).css().replace(/,/g, ', ');
};